import { Component } from 'react'
import PropTypes from 'prop-types'
import Collapse from '../../Widgets/Collapse'
import { graphqlFetch } from '../../../utilities'

class Faq extends Component {
    state = {}

    render() {
        return this.state.faqs ?
            (<div id="faqs" className="grid">
                {this.state.faqs
                    .sort((a, b) => a.order > b.order ? 1 : a.order < b.order ? -1 : 0)
                    .reduce((acc, item) => {
                        acc[acc[0].length > acc[1].length ? 1 : 0].push(item)
                        return acc
                    }, [[], []])
                    .map((faqGroup, i) => 
                        <div className="grid__cell--6" key={'faq__grid_cell--' + i}>
                            {faqGroup.map((faq, ii) => (
                                <Collapse 
                                    background={this.props.background || "#e0e0e0"}
                                    color={this.props.color || "#656565"}
                                    key={'faq__collapse--' + ii}
                                    title={faq.question}>
                                    <div dangerouslySetInnerHTML={{ __html: faq.answer}} />
                                </Collapse>))}
                        </div>)}
            </div>) : null
    }

    componentDidMount() {
        graphqlFetch('wcms3', `
            query {
              FAQ: faqs (order: { order: ASC }) {
                id
                order
                question
                answer
              }
            }`)
            .then(res => this.setState({ faqs: res.data.FAQ }))
    }
}

Faq.propTypes = {
    background: PropTypes.string,
    color: PropTypes.string
}

export default Faq